import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {setCanvasScale} from "../../actions/actionFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../analytics";

const MIN_SCALE = 1; // imageCanvasRef.pinchZoom.options.minZoom
const MAX_SCALE = 1.75; // imageCanvasRef.pinchZoom.options.maxZoom
const SCALE_STEP = 0.15; // imageCanvasRef.pinchZoom.options.maxZoom
const SCALE_MULTIPLIER = 100;

const roundToDecimals = (number) => {
  return Math.round(number * 100) / 100
}

const getCurrentPositionFromScale = (scale) => {
  return roundToDecimals((MAX_SCALE - scale) * SCALE_MULTIPLIER / (MAX_SCALE - MIN_SCALE))
}

const getCurrentScaleFromPosition = (position) => {
  return roundToDecimals(MIN_SCALE + (MAX_SCALE - MIN_SCALE) - ((MAX_SCALE - MIN_SCALE) * position / SCALE_MULTIPLIER));
}

const LookZoomer = (props) => {

  const {imageCanvasRef, setCanvasScale} = props;
  const [currentPosition, setCurrentPosition] = useState(100); // percentage taken from scroll! from 0 to 100
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(false);
  const [startPosition, setStartPosition] = useState(currentPosition);
  const [startZoomCenter, setStartZoomCenter] = useState(null); // object {x,y}

  const onZoomEnd = () => {
    setCurrentPosition(getCurrentPositionFromScale(imageCanvasRef.pinchZoom.getScale()));
  };

  useEffect(() => {
    document.addEventListener("pz_zoomend", onZoomEnd);
    return () => {
      document.removeEventListener("pz_zoomend", onZoomEnd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!imageCanvasRef.pinchZoom) {
    return null
  }

  // console.log("imageCanvas", imageCanvasRef);

  const zoomButtonClick = (type) => {
    // console.log("imageCanvasRef.pinchZoom.options.maxZoom", imageCanvasRef.pinchZoom.options.maxZoom);
    if (imageCanvasRef.pinchZoom.inAnimation || window.touchMove) {
      return false
    }
    let scale = 0;
    const currentScale = getCurrentScaleFromPosition(currentPosition);
    if (type === "plus") {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookZoomPlus);
      const nextScale = roundToDecimals(currentScale + SCALE_STEP); // 0.6 + 0.2
      scale = nextScale > MAX_SCALE ? MAX_SCALE : nextScale
    } else {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookZoomMinus);
      const prevScale = roundToDecimals(currentScale - SCALE_STEP); // 0.6 + 0.2
      scale = prevScale < MIN_SCALE ? MIN_SCALE : prevScale
    }
    setCurrentPosition(getCurrentPositionFromScale(scale))
    imageCanvasRef.pinchZoom.zoomToCenter(null, scale);
    setCanvasScale(scale);
  }

  const onMouseDown = (event) => {
    setIsDragging(true);
    setStartY(event.clientY);
    setStartPosition(currentPosition);
    const center = (imageCanvasRef.pinchZoom.getScale() === MIN_SCALE) ? {
      x: imageCanvasRef.pinchZoom.el.clientWidth / 2,
      y: imageCanvasRef.pinchZoom.el.clientHeight / 2,
    } : imageCanvasRef.pinchZoom.getCurrentZoomCenter();
    setStartZoomCenter(center);
  }

  const onMouseMove = (event) => {
    if (isDragging) {
      const diff = startY - event.clientY;
      const nextPosition = startPosition - diff <= 0
        ? 0
        : startPosition - diff >= 100
          ? 100
          : startPosition - diff
      setCurrentPosition(nextPosition);
      const scale = MAX_SCALE - (nextPosition / SCALE_MULTIPLIER);
      // console.log("nextPosition", nextPosition);
      // console.log("scale", scale);
      // console.log("================");
      imageCanvasRef.pinchZoom.scaleTo(scale, startZoomCenter);
      imageCanvasRef.pinchZoom.update();
    }
  }

  const onMouseUp = () => {
    setIsDragging(false);
    // imageCanvasRef.pinchZoom.end(); // not necessary
  }

  const thumbStyles = {
    transform: `translateY(${currentPosition}px)`
  }

  return (
    <div className="look-zoom">
      <IconButton className="look-icon look-icon--small look-icon--white2 look-zoom__button"
                  onClick={() => zoomButtonClick("plus")}>
        <AddIcon/>
      </IconButton>
      <div className="look-zoom__panel"
           onMouseDown={onMouseDown}
           onMouseMove={onMouseMove}
           onMouseUp={onMouseUp}
           onMouseLeave={onMouseUp}>
        <div className={"look-zoom__panel-thumb" + (isDragging ? " dragging" : "")} style={thumbStyles}/>
      </div>
      <IconButton className="look-icon look-icon--small look-icon--white2 look-zoom__button"
                  onClick={() => zoomButtonClick("minus")}>
        <RemoveIcon/>
      </IconButton>
    </div>
  )
};

LookZoomer.propTypes = {
  imageCanvasRef: PropTypes.object
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  setCanvasScale
};

export default connect(mapStateToProps, mapDispatchToProps)(LookZoomer)
